import {USER_ZONES_FETCHED, USER_SELECTED_ZONE, USER_FILTERED_ZONE, CLEAR_ZONE_SELECTION} from '../../actions/types';


export default function(state = [], action){
    switch (action.type){
        case USER_ZONES_FETCHED:
            return {list:action.payload};
        case USER_SELECTED_ZONE:
            return {...state, selectedZone:action.payload};
        case USER_FILTERED_ZONE:
            return {...state, filteredZone:action.payload};
        case CLEAR_ZONE_SELECTION:
            return {...state, selectedZone:0};
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Zones/index.js